module.exports = __webpack_public_path__ + "img/header-diamondJewelryBudgetMedium.bb34398.webp";